/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ActionButtonType {
    GET_PDF = 'GetPdf',
    SEND_EMAIL = 'SendEmail',
    NONE = 'None',
    CUSTOM = 'Custom',
    RUN_PEOPLE_MIGRATION = 'RunPeopleMigration',
}
